export default __webpack_public_path__ + "8c3bf61923982cfc532efb1ddc5e1a7c.svg";